<template>
    <MainSanPhamThueHuongDan> </MainSanPhamThueHuongDan>
    <!-- <div class="m-auto"><h3>  Thiết bị thay thế cho VPhone - VTablet </h3></div> -->
    
    <div class="container-fluid py-3 pd-product" style="">
        <!-- HEADER -->
        <div class="d-flex w-100 mt-1 mb-3 justify-content-center align-items-center rule-links">
            <li class="rule-item d-none">
                <a href="https://drive.google.com/file/d/1KRyvL4nu8Scs9Kj9Uxm5NkSheLhlFu6Z/view?usp=sharing"
                    target="_blank">
                    <span class="rule-text">
                        {{ currentLanguage.text_quetdinhVsound }}
                    </span>
                </a>
            </li>
            <li class="rule-item">
                <a href="https://drive.google.com/file/d/1bmAGjhjjquPXNKh_h9riNI1BQ_7JftmM/view?usp=sharing"
                    target="_blank">
                    <span class="rule-text">
                        Quy định phí thuê thiết bị thay thế VPhone-VTablet</span>
                </a>
            </li>
            <span class="rule-sep d-none">🌟</span>
            <li class="rule-item d-none">
                <a href="https://drive.google.com/file/d/1U4X88ttSYvK_vpjRFv_6YjVEoS2FT0Sl/view?usp=sharing"
                    target="_blank">
                    <span class="rule-text">
                        {{ currentLanguage.text_QuydinhGiaBan }}
                    </span>
                </a>
            </li>
            <span class="rule-sep">🌟</span>
            <li class="rule-item">
                <a href="https://drive.google.com/file/d/1Sk7dlcgcqjd52oGeC5mgwZVNvyZ6mxEE/view?usp=sharing"
                    target="_blank">
                    <span class="rule-text">
                        {{ currentLanguage.text_QuyDinhTaiXaPhuongTD }} </span>
                </a>
            </li>
            <span class="rule-sep d-none">🌟</span>
            <li class="rule-item d-none">
                <a href="https://docs.google.com/document/d/1qLYSyjf5_QPsxfjkTexev5FGC0FdlusI/edit?usp=sharing&ouid=106701618316117730835&rtpof=true&sd=true"
                    target="_blank">
                    <span class="rule-text">
                        Hợp đồng thuê thiết bị</span>
                </a>
            </li>
            <span class="rule-sep d-none">🌟</span>


        </div>
        <!-- PRODUCT GRID -->

        <div class="container-fluid  d-flex">
            <div class="category-sidebar d-none">
                <div v-for="c in categories" :key="c.id" class="category-item"
                    :class="{ topmenuactive: selectedCategory === c.id }" @click="selectedCategory = c.id">
                    {{ c.name }}
                </div>
            </div>
            <div class="product-content w-100">
                <div class="d-flex flex-wrap">

                    <div class="product-col cursor" v-for="p in filteredProducts" :key="p.id" style="cursor: pointer;">
                        <div class="product-box" @click="openDetail(p)">
                            <!-- IMAGE -->
                            <div class="img-box">
                                <img :src="'https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=' + getImages(p)[0]"
                                    @error="onImgError" />
                                <div v-if="p.sale > 0" class="sale-badge">
                                    -{{ p.sale }}%
                                </div>
                            </div>

                            <!-- INFO -->
                            <div class="p-2" style="line-height: normal;">
                                <div class="product-name">
                                    {{ p.name }}
                                </div>


                                <div class="price-box" v-if="p.giaThueTD > 0">

                                    <!-- CẢ 2 GIÁ -->
                                    <template v-if="p.priceTD > 0 && p.giaThueTD > 0">

                                        <span class="price ">

                                            {{ currentLanguage.textSanPhamThue }} 1 năm : {{ formatPrice(p.giaThueTD)
                                            }}/tháng
                                        </span>
                                        <span class="old-price d-none">
                                            {{ currentLanguage.textSanPhamMua }} : {{ formatPrice(p.priceTD) }}
                                        </span>

                                    </template>


                                    <!-- CHỈ GIÁ BÁN -->
                                    <template v-else-if="p.priceTD > 0">
                                        <span class="old-price d-none">
                                            {{ currentLanguage.textSanPham_GiaBan }} : {{ formatPrice(finalPrice(p)) }}
                                        </span>
                                    </template>

                                    <!-- CHỈ GIÁ THUÊ -->
                                    <template v-else>
                                        <span class="price ">
                                            {{ currentLanguage.textSanPhamThue }} 1 năm : {{ formatPrice(p.giaThueTD)
                                            }}/tháng
                                        </span>
                                    </template>
                                </div>
                                <div class="d-flex justify-content-center mt-2 d-none" style="color: black;"
                                    v-if="p.giaThue > 0">{{
                                        currentLanguage.textSanPham_TaiNoiKhac }}
                                </div>
                                <!-- Giá thật -->
                                <div class="price-box  d-none" v-if="p.price > 0 || p.giaThue > 0">

                                    <!-- CẢ 2 GIÁ -->
                                    <template v-if="p.price > 0 && p.giaThue > 0">
                                        <span class="price">
                                            {{ currentLanguage.textSanPhamThue }} : {{ formatPrice(p.giaThue) }}
                                        </span>
                                        <span class="old-price">
                                            {{ currentLanguage.textSanPhamMua }} : {{ formatPrice(finalPrice(p)) }}
                                        </span>

                                    </template>


                                    <!-- CHỈ GIÁ BÁN -->
                                    <template v-else-if="p.price > 0">
                                        <span class="old-price">
                                            {{ currentLanguage.textSanPhamBan }} : {{ formatPrice(finalPrice(p)) }}
                                        </span>
                                    </template>

                                    <!-- CHỈ GIÁ THUÊ -->
                                    <template v-else>
                                        <span class="price">
                                            {{ currentLanguage.textSanPhamThue }} : {{ formatPrice(p.giaThue) }}
                                        </span>
                                    </template>
                                </div>


                                <!-- Giá thí điểm -->

                                <!-- LIÊN HỆ -->
                                <!-- <div v-else class="contact-price">
                            <span class="price">{{ currentLanguage.header_text_lienHe }}</span>
                        </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- Quyết định-->

    </div>
    <!-- FLOATING CART BUTTON -->
    <div>

        <!-- 🛒 CART FAB -->
        <div class="cart-fab" @click="showCart = true">
            🛒
            <span v-if="cartItems.length" class="cart-badge">
                {{ cartItems.length }}
            </span>



            <!-- CHI TIẾT SP -->
            <ProductDetailSheet :product="product" @cart-updated="loadCart" />
        </div>

        <!-- 💬 CHAT -->
        <div class="chat-fab">💬</div>


        <MainCartSheet v-if="showCart" :items="cartItems" @close="showCart = false" @remove="removeCartItem" />
    </div>


    <!-- FLOATING BUTTON -->
    <div class="chat-fab mt-5" @click="showChat = true">
        <img src="https://web.vimass.vn/VimassMedia/services/VMMedia/getImage?id=1767779372560sibSF"
            style="border-radius: 50%;" alt="chatbot" width="28" height="28" />

    </div>

    <!-- CHAT MODAL -->
    <transition name="chat-slide">
        <div v-if="showChat" class="chat-overlay">
            <ProductChatbot :products="products" @close="showChat = false" />
        </div>
    </transition>
    <transition name="sheet-slide">
        <div v-if="showDetail" class="sheet-overlay" @click.self="closeDetail">
            <ProductDetailSheet :product="selectedProduct" @close="closeDetail" @buy="openCheckout" />
        </div>
    </transition>
    <!-- // đặt hàng -->
    <!-- <transition name="sheet-slide">
  <div v-if="showCheckout" class="sheet-overlay">
    <CheckoutSheet
      :product="checkoutProduct"
      @close="showCheckout = false"
    />
  </div>
</transition> -->
</template>

<script>
import MainProductChatbot from './MainProductChatbot.vue';
import ProductDetailSheet from './MainDetalProduct.vue';
import CheckoutSheet from './MainCheckoutSheet.vue';
import MainCartSheet from './MainCartSheet.vue';
import productVi from "@/components/json/jsonProduct.json"
// eslint-disable-next-line no-unused-vars
import productEn from "@/components/json/jsonProductEn.json"
import { languages } from '@/components/languages';
import MainSanPhamThueHuongDan from './MainSanPhamThueHuongDan.vue';

export default {
    name: "ProductList",
    components: {
        ProductChatbot: MainProductChatbot, MainCartSheet,MainSanPhamThueHuongDan,
        ProductDetailSheet,
        // eslint-disable-next-line vue/no-unused-components
        CheckoutSheet
    },
    data() {
        return {

            keyword: "",
            products: require("@/components/json/jsonProduct.json"),
            showChat: false,

            // 👇 detail
            showDetail: false,
            selectedProduct: null,
            showCheckout: false,
            showCart: false,

            currentLanguage: languages.vi,
            checkoutProduct: null,
            cartCount: 0,
            cartItems: JSON.parse(localStorage.getItem("cart") || "[]"),
            lang: "",
            selectedCategory: 0,
            categories: [
                { id: 0, name: "Tất cả" },
                { id: 1, name: "Loa" },
                { id: 2, name: "Điện thoại" },
                { id: 3, name: "Tablet" },
                { id: 4, name: "Máy Tính" },
                { id: 5, name: "Thẻ" }
            ],
        };
    },
    computed: {
        filteredProducts() {
            return this.products.filter(p => {
                // ❌ Ẩn sản phẩm id 810
                if (Number(p.id) === 810) return false;
                if (Number(p.id) === 8101) return false;
                 if (Number(p.id) === 1213) return false;
                  if (Number(p.id) === 11234) return false;
                const matchKeyword = p.name
                    .toLowerCase()
                    .includes(this.keyword.toLowerCase());

                const matchCategory =
                    this.selectedCategory === 0 ||
                    Number(p.categoryid) === this.selectedCategory;

                return matchKeyword && matchCategory;
            });
        },
    },
    mounted() {
        this.loadCart();

        this.lang = localStorage.getItem("languages") || "vi";

        if (this.lang === "vi") {
            this.products = productVi;

        } else {
            this.products = productVi;
        }

        window.addEventListener("cartUpdated", this.loadCart)
    },
    created() {
        const savedLanguage = localStorage.getItem("languages") || "vi";
        if (savedLanguage && languages[savedLanguage]) {
            this.currentLanguage = languages[savedLanguage];
        }
    },
    beforeUnmount() {

        window.removeEventListener("cartUpdated", this.loadCart)

    },
    methods: {
        slugify(name) {
            return name
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/\s+/g, "-")
                .replace(/[^\w-]+/g, "");
        },
        // openDetail(p) {
        //     this.selectedProduct = p;
        //     this.showDetail = true;
        // },
        openDetail(p) {
            const slug = this.slugify(p.name);
            const url = `/chitiet/${slug}`;

            window.open(url, '_blank');
        },
        openCheckout(product) {
            this.checkoutProduct = product;
            this.showCheckout = true;
        },
        closeDetail() {
            this.showDetail = false;
        },
        getImages(p) {
            if (!p.image) return [];
            return p.image.split(";").filter(i => i);
        },
        formatPrice(v) {
            if (!v || v === 0) return "0";

            // >= 1 triệu
            if (v >= 1_000_000) {
                let trieu = v / 1_000_000;
                let value = trieu.toFixed(1).replace(".0", "").replace(".", ",");
                return value + " tr";
            }

            // >= 10 nghìn
            if (v >= 10_000) {
                let k = v / 1_000;
                let value = k.toFixed(1).replace(".0", "").replace(".", ",");
                return value + "K";
            }

            // từ 1.000 đến < 10.000 → 5K4
            if (v >= 1_000) {
                let nghin = Math.floor(v / 1000);      // 5
                let tram = Math.floor((v % 1000) / 100); // 4
                return tram > 0 ? `${nghin}K${tram}` : `${nghin}K`;
            }

            // < 1 nghìn
            return v.toLocaleString("vi-VN");
        },
        loadCart() {
            this.cartItems = JSON.parse(localStorage.getItem("cart") || "[]")
        },
        removeCartItem(index) {
            this.cartItems.splice(index, 1)
            localStorage.setItem("cart", JSON.stringify(this.cartItems))
            window.dispatchEvent(new Event("cartUpdated"))
        },

        finalPrice(p) {
            return p.sale > 0
                ? p.price - (p.price * p.sale) / 100
                : p.price;
        }
    }
};

</script>

<style scoped>
.product-col {
    width: 14.2%;
    /* 100% / 8 = 12.5% */
    padding: 6px;
}

.category-sidebar {
    width: 10%;
    min-width: 160px;
    /* chống bị quá nhỏ */
    background: #f7f7f7;
    border-radius: 12px;
    padding: 10px;
}

.category-item {
    padding: 10px 12px;
    border-radius: 8px;
    cursor: pointer;
    transition: 0.2s;
    font-size: 14px;
}

.category-item:hover {
    background: #eee;
}

.category-item.active {
    background: #e9ecef;
    font-weight: 600;
}

.product-content {
    width: 90%;
    padding-left: 16px;
}

@media (max-width: 768px) {
    .container-fluid {
        flex-direction: column;
    }

    .category-sidebar {
        width: 100%;
        display: flex;
        overflow-x: auto;
        gap: 8px;
    }

    .product-content {
        width: 100%;
        padding-left: 0;
    }

    .category-item {
        white-space: nowrap;
        background: #f1f1f1;
    }
}

@media (max-width: 1200px) {
    .product-col {
        width: 16.66%;
        /* 6 sp */
    }
}

@media (max-width: 992px) {
    .product-col {
        width: 25%;
        /* 4 sp */
    }
}

@media (max-width: 576px) {
    .product-col {
        width: 50%;
        /* 2 sp */
    }
}

.rule-links {
    flex-wrap: wrap;
    gap: 8px;
}

.rule-item {
    list-style: none;
}

.rule-text {
    color: #0066cc;
    font-size: 18px;
    text-align: center;
}

/* 🌟 separator */
.rule-sep {
    margin: 0 8px;
}

/* 📱 Mobile */
@media (max-width: 576px) {
    .rule-links {
        flex-direction: column;
        align-items: center;
    }

    .rule-sep {
        display: none;
        /* Ẩn 🌟 khi xuống mobile */
    }

    .rule-item {
        width: 100%;
        text-align: center;
    }

    .rule-text {
        display: block;
        font-size: 16px;
        line-height: 1.5;
        text-align: start;
    }
}

/* .pd-product {
    padding-left: 50px;
    padding-right: 50px;
} */

.sheet-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, .4);
    z-index: 9999;
}

/* animation */
.sheet-slide-enter-active,
.sheet-slide-leave-active {
    transition: all .25s ease;
}

.sheet-slide-enter-from,
.sheet-slide-leave-to {
    opacity: 0;
}

.chat-fab {
    position: fixed;
    bottom: 250px;
    right: 24px;
    width: 56px;
    height: 56px;
    background: #ffffff;
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    cursor: pointer;
    box-shadow: 0 8px 20px rgba(0, 0, 0, .3);
    z-index: 999;

    animation: shake 4s infinite;
    transition: transform 0.2s ease;
}

.chat-fab:hover {
    transform: scale(1.1);
}

.chat-overlay {
    position: fixed;
    bottom: 90px;
    right: 24px;
    z-index: 1000;
}

@keyframes shake {
    0% {
        transform: rotate(0);
    }

    2% {
        transform: rotate(5deg);
    }

    4% {
        transform: rotate(-5deg);
    }

    6% {
        transform: rotate(4deg);
    }

    8% {
        transform: rotate(-4deg);
    }

    10% {
        transform: rotate(0);
    }

    100% {
        transform: rotate(0);
    }
}

.chat-slide-enter-active,
.chat-slide-leave-active {
    transition: all 0.3s ease;
}

.chat-slide-enter-from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
}

.chat-slide-enter-to {
    opacity: 1;
    transform: translateY(0) scale(1);
}

.chat-slide-leave-from {
    opacity: 1;
    transform: translateY(0) scale(1);
}

.chat-slide-leave-to {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
}

.chat-fab::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: rgba(11, 3, 255, 0.4);
    animation: pulse 2s infinite;
    z-index: -1;
}

@media (max-width: 768px) {
    .container {
        margin: 0 auto;
        height: auto;
        text-align: center;
        overflow: hidden;
        border-radius: 0px;
    }

    .pd-product {
        padding-left: 10px;
        padding-right: 10px;
    }

    .price-box {
        justify-content: center;
        display: flex;

        text-align: center;
    }

    .old-price {
        /* margin-left: 6px; */
        font-size: 13px;
        font-weight: 700;
        color: #1449d8;
    }
}

@keyframes pulse {
    0% {
        transform: scale(1);
        opacity: .6;
    }

    100% {
        transform: scale(1.6);
        opacity: 0;
    }
}

/* PRODUCT BOX */
.product-box {
    background: #fff;
    border: 1px solid #eee;
    transition: 0.2s;
    line-height: 2;
    border-radius: 10px;
    /* height: 100%; */
}

.product-box:hover {
    border-color: #086dac;
    transform: translateY(-2px);
}

/* IMAGE */
.img-box {
    position: relative;
    width: 100%;
    aspect-ratio: 1 / 1;
    background: #fafafa;
    overflow: hidden;
    border-radius: 10px;
}

.img-box img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

/* SALE BADGE */
.sale-badge {
    position: absolute;
    top: 6px;
    left: 6px;
    background: #ff424e;
    color: #fff;
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 4px;
}

/* PRODUCT NAME */
.product-name {
    font-size: 14px;
    line-height: 1.3;
    font-weight: 600;
    /* height: 34px; */
    overflow: hidden;
    text-align: center;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin: 5px !important;
}

/* PRICE */
.price-box {
    margin-top: 6px;
    text-align: center;
}

.price {
    color: #ff424e;
    font-weight: 700;
    font-size: 13px;
}

.old-price {
    margin-left: 6px;
    font-size: 13px;
    font-weight: 700;
    color: #1449d8;
}

.contact-price {
    font-size: 13px;
    color: #999;
    margin-top: 6px;
    text-align: center;
}

/* SOLD */
.sold {
    font-size: 12px;
    color: #777;
    margin-top: 4px;
}

.cart-fab {
    position: fixed;
    bottom: 320px;
    /* nằm trên chatbot */
    right: 24px;
    width: 56px;
    height: 56px;
    background: #ff9800;
    /* 🎨 MÀU GIỎ HÀNG */
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    cursor: pointer;
    box-shadow: 0 8px 20px rgba(0, 0, 0, .3);
    z-index: 9999;

    animation: shake 4s infinite;
    transition: transform 0.2s ease;
}

.cart-fab:hover {
    transform: scale(1.1);
}

/* 🌊 pulse giống chatbot */
.cart-fab::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: rgba(255, 152, 0, 0.45);
    /* cùng màu nhưng mờ */
    animation: pulse 2s infinite;
    z-index: -1;
}

/* 🔴 badge số lượng */
.cart-badge {
    position: absolute;
    top: 6px;
    right: 6px;
    background: #ff424e;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 999px;
}
</style>
